import { getSevColor } from '@/constants'
import { fmtTime } from './TimeWindow'
import { METRICS, type ChartPoint } from './types'

/**
 * Severity timeline strips: one row per headline metric, one colored block per
 * aggregation window (tier from /api/analysis → live WS). Answers "when did
 * stress start, and which metrics did it spread to" without reading any lines.
 * Grey = no tier data for that window.
 */
export default function SeverityStrips({ data }: { data: ChartPoint[] }) {
  if (!data.length) {
    return (
      <div style={{ padding: '10px 0', color: 'var(--t-2)', fontSize: 11 }}>
        Severity timeline: no windows in range.
      </div>
    )
  }
  const first = data[0]!.ts
  const last = data[data.length - 1]!.ts

  return (
    <div style={{ border: '0.5px solid var(--bd-1)', borderRadius: 'var(--radius)', padding: '10px 12px' }}>
      <div style={{ fontSize: 10, fontWeight: 600, color: 'var(--t-1)', textTransform: 'uppercase', letterSpacing: '.05em', marginBottom: 8 }}>
        Severity timeline
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        {METRICS.map((m) => (
          <div key={m.key} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ width: 130, fontSize: 10, color: 'var(--t-1)', flexShrink: 0 }}>{m.label}</span>
            <div style={{ flex: 1, display: 'flex', gap: 1, height: 12 }}>
              {data.map((pt) => {
                const t = pt[`${m.key}_tier`]
                const tier = t === 0 || t === 1 || t === 2 ? t : null
                return (
                  <div
                    key={pt.ts}
                    title={`${fmtTime(pt.ts)} — ${tier == null ? 'no data' : ['critical', 'warning', 'healthy'][tier]}`}
                    style={{
                      flex: 1,
                      minWidth: 2,
                      background: tier == null ? 'var(--bg-3)' : getSevColor(tier),
                      opacity: tier == null ? 0.6 : tier === 2 ? 0.45 : 1,
                      borderRadius: 1,
                    }}
                  />
                )
              })}
            </div>
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6, marginLeft: 138, fontSize: 9, color: 'var(--t-2)' }}>
        <span>{fmtTime(first)}</span>
        <span>{fmtTime(last)}</span>
      </div>
    </div>
  )
}
